import { style } from "@vanilla-extract/css";
import { vars } from "../../../styles";

export const elementNewsLinkStyles = style({
  display: "inline-flex",
  alignItems: "center",
  gap: vars.space.xs,
  maxWidth: "100%",
  textDecoration: "underline",
  color: "currentColor",
  fontFamily: vars.fonts.bold,
  textUnderlineOffset: "0.12em",
});
